export default "__VITE_ASSET__379a70aa__"